import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=5623c386&scoped=true&"
import script from "./Ranking.vue?vue&type=script&lang=ts&"
export * from "./Ranking.vue?vue&type=script&lang=ts&"
import style0 from "./Ranking.vue?vue&type=style&index=0&id=5623c386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5623c386",
  null
  
)

export default component.exports